import React from "react";
import MuiDivider from "@mui/material/Divider";

import { useDividerStyles } from "./Divider.styles";
import { DividerProps } from "./Divider.types";
import { Box } from "..";
import { extractBoxProps } from "./Divider.helpers";

function Divider(props: DividerProps): JSX.Element {
  const { children, ...other } = props;

  const dividerClasses = useDividerStyles();

  const boxProps = React.useMemo(() => {
    return extractBoxProps(props);
  }, [props]);

  return (
    <Box {...boxProps}>
      {children ? (
        <Box display="flex" alignItems="center">
          <Box flex={1}>
            <MuiDivider {...other} classes={dividerClasses} />
          </Box>
          {children}
          <Box flex={1}>
            <MuiDivider {...other} classes={dividerClasses} />
          </Box>
        </Box>
      ) : (
        <MuiDivider {...other} classes={dividerClasses} />
      )}
    </Box>
  );
}

export default Divider;
